/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const formatDate = (dateStr) => {
    const dateParts = dateStr.split('/');
    if (dateParts.length === 3) {
        // Assuming format is DD/MM/YYYY
        return new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
    } else {
        // Assuming ISO format YYYY-MM-DD
        return new Date(dateStr);
    }
};


const { state } = store("gt/ctv", {
    state: {
        get currentDisponibilites(){
            const context = getContext();
            const { idProduct, campingKey, isCamping } = context;
            const { stays } = state;

            const Arrival = formatDate(Cookies.get('gtArrival'));
            const Departure = formatDate(Cookies.get('gtDeparture'));

            context.datesTitles = "";

            if(isCamping){

                if (!stays || Object.keys(stays).length === 0) {
                    return [];
                }

                let campingStays = [];
                for (const stay of Object.values(stays)) {
                    
                    if (stay.length === 0) {
                        continue;
                    }

                    if(stay[0].campingkey == campingKey){
                        campingStays.push(...stay);
                    }
                }

                const disponibilites = campingStays.filter(stay => {
                    const dateBegin = formatDate(stay.productAvailabilityDate.dateBegin.split('T')[0]);
                    const dateEnd = formatDate(stay.productAvailabilityDate.dateEnd.split('T')[0]);
                    return dateBegin.getTime() === Arrival.getTime() && dateEnd.getTime() === Departure.getTime();
                });

                disponibilites.sort((a, b) => a.gtPriceDiscounted - b.gtPriceDiscounted);

                if(disponibilites.length > 0) return disponibilites;

                const contrepropositions = campingStays.filter(stay => {
                    const dateBegin = formatDate(stay.productAvailabilityDate.dateBegin.split('T')[0]);
                    const dateEnd = formatDate(stay.productAvailabilityDate.dateEnd.split('T')[0]);
                    return dateBegin.getTime() !== Arrival.getTime() || dateEnd.getTime() !== Departure.getTime();
                });

                contrepropositions.sort((a, b) => a.gtPriceDiscounted - b.gtPriceDiscounted);

                if(contrepropositions.length > 0) return contrepropositions;

                return [];
            }
            
            // Herbegement

            if(!idProduct) return [];

            if (!stays || !(idProduct in stays) || stays[idProduct].length === 0) {
                return [];
            }
            else{

                const Arrival = formatDate(Cookies.get('gtArrival'));
                const Departure = formatDate(Cookies.get('gtDeparture'));

                const disponibilites = stays[idProduct].filter(stay => {
                    const dateBegin = formatDate(stay.productAvailabilityDate.dateBegin.split('T')[0]);
                    const dateEnd = formatDate(stay.productAvailabilityDate.dateEnd.split('T')[0]);
                    return dateBegin.getTime() === Arrival.getTime() && dateEnd.getTime() === Departure.getTime();
                });

                disponibilites.sort((a, b) => a.gtPriceDiscounted - b.gtPriceDiscounted);

                if(disponibilites.length > 0) return disponibilites;

                const contrepropositions = stays[idProduct].filter(stay => {
                    const dateBegin = formatDate(stay.productAvailabilityDate.dateBegin.split('T')[0]);
                    const dateEnd = formatDate(stay.productAvailabilityDate.dateEnd.split('T')[0]);
                    return dateBegin.getTime() !== Arrival.getTime() || dateEnd.getTime() !== Departure.getTime();
                });

                contrepropositions.sort((a, b) => a.gtPriceDiscounted - b.gtPriceDiscounted);

                if (contrepropositions.length > 5) {
                    contrepropositions.length = 5;
                }

                if(contrepropositions.length > 0) return contrepropositions;
            }
        },
        get mainStay(){
            const { currentDisponibilites } = state;
            const context = getContext();

            context.mainStay = currentDisponibilites[0];

            return currentDisponibilites[0];
        },
        get statut (){
            const {mainStay} = state;
            const Arrival = formatDate(Cookies.get('gtArrival'));
            const Departure = formatDate(Cookies.get('gtDeparture'));

            if(!mainStay) return 'indisponible';
            if(mainStay.productAvailabilityDate){
                const dateBegin = formatDate(mainStay.productAvailabilityDate.dateBegin.split('T')[0]);
                const dateEnd = formatDate(mainStay.productAvailabilityDate.dateEnd.split('T')[0]);
                if(dateBegin.getTime() === Arrival.getTime() && dateEnd.getTime() === Departure.getTime()){
                    return 'disponible';
                }
            }
            return 'contreproposition';

        },
        get titre(){
            const {statut} = state;
            if(statut === 'disponible') return state.titres.disponible;
            if(statut === 'contreproposition') return state.titres.contreproposition;
            return state.titres.indisponible;
        },
        get gtPriceDiscounted(){
            const { mainStay } = state;
            if(!mainStay) return 0;
            const { gtPriceDiscounted } = mainStay;
            return gtPriceDiscounted;
        },
        get gtPriceOriginal(){
            const { mainStay } = state;
            if(!mainStay) return 0;
            const { gtPriceOriginal } = mainStay;
            return gtPriceOriginal;
        },
        get txtFinalDates(){
            const { mainStay } = state;
            if(!mainStay) return '';
            return mainStay.productAvailabilityDate.txtFinalDates
        },
        get nextDispo(){

            if(state.statut != "indisponible") return;
            const context = getContext();
        
            // Fonction pour parser les dates (format DD/MM/YYYY)
            const parseDate = (dateString) => {
                const [day, month, year] = dateString.split('/').map(Number);
                return new Date(year, month - 1, day); // Mois 0-indexé
            };
        
            // Fonction pour formater les dates
            const formatFullDate = (date) => {
                const formatter = new Intl.DateTimeFormat('fr-FR', {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                });
                return formatter.format(date);
            };
        
            // Dates demandées
            const rawArrival = Cookies.get('gtArrival');
            const rawDeparture = Cookies.get('gtDeparture');
        
            const requestedArrival = parseDate(rawArrival);
            const requestedDeparture = parseDate(rawDeparture);
        
            if (isNaN(requestedArrival) || isNaN(requestedDeparture)) {
                context.isIndisponible = true;
                return;
            }
        
            const requestedDuration = (requestedDeparture - requestedArrival) / (1000 * 60 * 60 * 24); // Durée demandée en jours
        

            // Récupérer les plannings
            const planningData = state.planings;


            if(!planningData) return;
            let specificProductPlanning = null;
            for (const planning of planningData) {
                const productPlanning = planning?.GetProductsPlanningResult?.ProductsPlanning?.ProductPlanning || [];
                specificProductPlanning = productPlanning.find(product => product.ProductID == parseInt(context.idProduct));
                if (specificProductPlanning) break;
            }

            

            if (!specificProductPlanning) {
                context.isIndisponible = true;
                return;
            }

            if(!specificProductPlanning.AvailabilityPeriods) return;
        
            const availabilityPeriods = Array.isArray(specificProductPlanning.AvailabilityPeriods.AvailabilityPeriod)
                ? specificProductPlanning.AvailabilityPeriods.AvailabilityPeriod
                : [specificProductPlanning.AvailabilityPeriods.AvailabilityPeriod];

        
            // Construire toutes les disponibilités
            const allAvailabilities = availabilityPeriods.map(period => {
                const beginDate = new Date(period.BeginningDate);
                const endDate = new Date(period.EndingDate);
        
                if (isNaN(beginDate) || isNaN(endDate)) {
                    return null;
                }
        
                const periodDuration = (endDate - beginDate) / (1000 * 60 * 60 * 24); // Durée en jours
                const dateDiff = Math.abs(beginDate - requestedArrival); // Distance en millisecondes
        
                return {
                    beginDate,
                    endDate,
                    periodDuration,
                    dateDiff,
                };
            }).filter(av => av !== null); // Exclure les périodes invalides

        
            // Trier par proximité de la date demandée
            const sortedAvailabilities = allAvailabilities.sort((a, b) => a.dateDiff - b.dateDiff);
        
            // Sélectionner la meilleure disponibilité
            let closestAvailability = null;
        
            for (const availability of sortedAvailabilities) {
                const potentialEndDate = new Date(availability.beginDate);
                potentialEndDate.setDate(potentialEndDate.getDate() + requestedDuration);
        
                // Vérifier si la durée demandée peut être respectée dans cette période
                if (potentialEndDate <= availability.endDate) {
                    closestAvailability = {
                        beginDate: availability.beginDate,
                        endDate: potentialEndDate,
                    };
                    break;
                }
            }
        
            if (!closestAvailability && sortedAvailabilities.length > 0) {
                // Si aucune période exacte trouvée, prendre la première disponible
                const firstAvailable = sortedAvailabilities[0];
                closestAvailability = {
                    beginDate: firstAvailable.beginDate,
                    endDate: firstAvailable.endDate, // Durée demandée non respectée
                };
            }
            context.datesTitles = state.titres.prochainesDisponibilites;
            return state.titres.du + ` ${formatFullDate(closestAvailability.beginDate)} ${state.titres.au} ${formatFullDate(closestAvailability.endDate)}`;
            
        },
        get isDisponible(){
            return state.statut === 'disponible';
        },
        get isContreproposition(){
            return state.statut === 'contreproposition';
        },
        get isIndisponible(){
            return state.statut === 'indisponible';
        },
    },
    actions: {
        loadStays : () => {

            const context = getContext();
            const { idProduct } = context;
            const { mainStay } = state;
            
            setTimeout(() => {
                if(mainStay){
                    const inputMainStay = document.getElementById(mainStay.secureHolidayProductAvailabilitySpecifications.uniqueStayId);
                    if(inputMainStay) {
                        inputMainStay.checked = true;
                        inputMainStay.setAttribute('checked', 'checked');
                    }
                }
            }, 100);


        },
        setMainStay: () => {
            const element = getElement();
            const context = getContext();
            const idStay = parseInt(element.ref.getAttribute('id'));
            const mainStay = state.currentDisponibilites.find(stay => stay.secureHolidayProductAvailabilitySpecifications.uniqueStayId === idStay);
            context.mainStay = mainStay;
        }
    }
});
